// outbox-idempotency-key.ts
//
// B2 intent-key derivation, split out of delivery-outbox.ts to keep that file
// under the 200-line budget. Leaf module: no dependency on the outbox file
// format, so delivery-outbox.ts imports FROM here (no import cycle).
import { createHash } from "node:crypto";

/**
 * B2: a stable key for the INTENT behind a send — mission + kind +
 * correlation. Deliberately NOT derived from the message body (the same
 * escalation can be re-rendered with different redaction) and NOT from time
 * or `event_id` (a later attempt rebuilding the same intent generates a new
 * one, which is exactly the duplicate-post case this prevents).
 */
export function deriveOutboxIdempotencyKey(
  missionId: string,
  kind: string,
  correlationId: string,
): string {
  return (
    createHash("sha256")
      // Separator is a literal NUL, written as an ESCAPE rather than a raw
      // byte: a raw 0x00 in the source makes git classify this whole file as
      // binary, so every later `git diff` of it prints "Bin 4429 -> 6698
      // bytes" instead of the change — review goes blind on exactly the file
      // that carries the duplicate-post defence. Identical bytes at runtime,
      // identical hash. NUL (not "|" or ":") because no mission id / kind /
      // correlation id can contain it, so two different triples cannot
      // collide by re-splitting the same joined string.
      .update(`${missionId}\u0000${kind}\u0000${correlationId}`, "utf8")
      .digest("hex")
      .slice(0, 16)
  );
}
